module.exports = __webpack_public_path__ + "static/img/m_Deyubg_03.d622ebf6.jpg";